angular.module('bmsApp.trugreen.quote').factory('TGVisitSvc', function ($q, $modal, CRUDSvc, TG_VISIT_API) {
	var self = {
		index: function (params) {
			return CRUDSvc.get(TG_VISIT_API.INDEX, params);
		},
		read: function (id, params) {
			return CRUDSvc.get(TG_VISIT_API.READ + id, params);
		},
		save: function (params) {
			return CRUDSvc.post(TG_VISIT_API.SAVE, params);
		},
		calendarEvents: function (params) {
			return CRUDSvc.get(TG_VISIT_API.CALENDAR_EVENTS, params);
		},
		showAddVisitModal: function() {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/trugreen/job/templates/modals/AddVisitModal.html',
				controller: 'AddVisitModalCtrl',
				size: 'lg',
				backdrop: 'static' // disable click-outside closing modal
			});
			return modalInstance.result;
		},
		close: function(params) {
			return CRUDSvc.post(TG_VISIT_API.CLOSE, params);
		}
	};
	return self;

}).constant('TG_VISIT_API', {
	INDEX: 'api/trugreen/visits',
	READ: 'api/trugreen/visit/read/',
	SAVE: 'api/trugreen/visit/save',
	CLOSE: 'api/trugreen/visit/close',
	CALENDAR_EVENTS: 'api/trugreen/visit/calendarEvents'
});
